import { Route } from '@angular/router';

export const onlineTournamentRoutes: Route[] = [
    {
        path: 'tournaments/online',
        loadComponent: () =>
            import('./pages/online-tournaments/online-tournaments.component').then((c) => c.OnlineTournamentsComponent),
    },
    {
        path: 'tournaments/online/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/online-tournaments/view/online-tournament-view.component').then(
                (c) => c.OnlineTournamentViewComponent
            ),
    },
    {
        path: 'tournaments/online/:id/:view',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/online-tournaments/view/online-tournament-view.component').then(
                (c) => c.OnlineTournamentViewComponent
            ),
    },
];
